import '.a{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.ac{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ad{max-width:77.5rem;}.ssr-plugin'
import '.h1{justify-content:stretch;}.ssr-plugin'
import '.bu{position:sticky;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.c0{z-index:10;}.ssr-plugin'
import '.gb{padding-block:1rem;}.ssr-plugin'
import '.gc{height:3rem;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.aj{flex-wrap:wrap;}.ssr-plugin'
import '.h3{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fv{margin-top:2rem;}.ssr-plugin'
import '.gh{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const CreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a r ax b do"
      >
        <div className="ac a t ax b"
        >
          <div className="n ad a b h1 bu bf c0"
            style={{
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            <nav className="gb gc a ag t aj"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="h3 a b r fv gh n ad"
            style={{
              gap: gap, // 8rem is padding + navbar height
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
